import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/outline'

const Arrow = (p: {from: number, to: number}) => {
  if (p.from === undefined || p.to === undefined || p.from === p.to) {
    return <div></div>
  }
  return Number(p.from) < Number(p.to) ? <ArrowUpIcon className="h-5 w-5 text-yellow-700" /> : <ArrowDownIcon className="h-5 w-5 text-green-700" />
}

export default Arrow